export default "<div  [class]=\"(typeNotice ? 'errorWrapper ' + typeNotice : 'errorWrapper')\">\n  {{textNotice}}\n</div>"